export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5012.8e848b04.jpg";